import { render, staticRenderFns } from "./ZhuanJiaWeiYuanHui.vue?vue&type=template&id=1ecc9dc4&scoped=true&"
import script from "./ZhuanJiaWeiYuanHui.vue?vue&type=script&lang=js&"
export * from "./ZhuanJiaWeiYuanHui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc9dc4",
  null
  
)

export default component.exports